module.exports = __webpack_public_path__ + "media/assets/Upload-23a8f6eb198e596bbbcac99ff18800a4.svg";